import script from "./ExpertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpertModal.vue?vue&type=script&setup=true&lang=js"

import "./ExpertModal.vue?vue&type=style&index=0&id=10f5479a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10f5479a"]])

export default __exports__